export const HISTORY_SEASONS = [
    {
        "year": 2016,
        "standings": [
            {
                "rank": 1,
                "owner": "Julian Fife",
                "team": "Fife'd Your Wife",
                "wins": 8,
                "losses": 5,
                "ties": 0,
                "pf": 1436.6,
                "pa": 1324.1
            },
            {
                "rank": 2,
                "owner": "Jeremy Ansah",
                "team": "Harambe Beatyerson",
                "wins": 6,
                "losses": 7,
                "ties": 0,
                "pf": 1379.8,
                "pa": 1391.5
            },
            {
                "rank": 3,
                "owner": "Snap Palmer",
                "team": "Straight Cash Homie",
                "wins": 7,
                "losses": 6,
                "ties": 0,
                "pf": 1477.9,
                "pa": 1373
            },
            {
                "rank": 4,
                "owner": "Derek Ansah",
                "team": "Team Ansah",
                "wins": 8,
                "losses": 5,
                "ties": 0,
                "pf": 1633.9,
                "pa": 1435.8
            },
            {
                "rank": 5,
                "owner": "TJ Knoll",
                "team": "Don Julio",
                "wins": 7,
                "losses": 6,
                "ties": 0,
                "pf": 1398.1,
                "pa": 1305.4
            },
            {
                "rank": 6,
                "owner": "Tanner Harrison",
                "team": "Dak's Out For Harambe",
                "wins": 9,
                "losses": 4,
                "ties": 0,
                "pf": 1436.8,
                "pa": 1254.9
            },
            {
                "rank": 7,
                "owner": "Dylan Harris",
                "team": "Taylor Gang",
                "wins": 10,
                "losses": 3,
                "ties": 0,
                "pf": 1445.9,
                "pa": 1378.2
            },
            {
                "rank": 8,
                "owner": "Michael Klein",
                "team": "A Shot In the Dark",
                "wins": 6,
                "losses": 7,
                "ties": 0,
                "pf": 1432.3,
                "pa": 1400.6
            },
            {
                "rank": 9,
                "owner": "Adam Kester",
                "team": "Team Kester",
                "wins": 5,
                "losses": 8,
                "ties": 0,
                "pf": 1265.2,
                "pa": 1494.1
            },
            {
                "rank": 10,
                "owner": "Austin Clouthier",
                "team": "Slob on my cobb Clouthier",
                "wins": 6,
                "losses": 7,
                "ties": 0,
                "pf": 1360.9,
                "pa": 1461
            },
            {
                "rank": 11,
                "owner": "Brendan Kearney",
                "team": "SCam'd Yo Gurley",
                "wins": 2,
                "losses": 11,
                "ties": 0,
                "pf": 1293.8,
                "pa": 1510.8
            },
            {
                "rank": 12,
                "owner": "Justin Wolf",
                "team": "Team Wolf",
                "wins": 4,
                "losses": 9,
                "ties": 0,
                "pf": 1299.3,
                "pa": 1531.1
            }
        ]
    },
    {
        "year": 2017,
        "standings": [
            {
                "rank": 1,
                "owner": "Julian Fife",
                "team": "Hangin' With Hernandez",
                "wins": 6,
                "losses": 6,
                "ties": 0,
                "pf": 1397.9,
                "pa": 1259.5
            },
            {
                "rank": 2,
                "owner": "Justin Wolf",
                "team": "Smokin on Cooks in the Hotbox",
                "wins": 9,
                "losses": 3,
                "ties": 0,
                "pf": 1381.7,
                "pa": 1237.7
            },
            {
                "rank": 3,
                "owner": "Matt Yamane",
                "team": "The Free Agents",
                "wins": 5,
                "losses": 7,
                "ties": 0,
                "pf": 1225.9,
                "pa": 1300.9
            },
            {
                "rank": 4,
                "owner": "Tanner Harrison",
                "team": "Oysters, Clams And Cockles",
                "wins": 7,
                "losses": 5,
                "ties": 0,
                "pf": 1280.3,
                "pa": 1298.4
            },
            {
                "rank": 5,
                "owner": "Adam Kester",
                "team": "Jacquizz In my pants",
                "wins": 6,
                "losses": 6,
                "ties": 0,
                "pf": 1293.7,
                "pa": 1258.8
            },
            {
                "rank": 6,
                "owner": "Austin Clouthier",
                "team": "Axe Capital",
                "wins": 4,
                "losses": 8,
                "ties": 0,
                "pf": 1128.3,
                "pa": 1181.3
            },
            {
                "rank": 7,
                "owner": "Jeremy Ansah",
                "team": "Gimme That Woodhead",
                "wins": 9,
                "losses": 3,
                "ties": 0,
                "pf": 1271.3,
                "pa": 1199.4
            },
            {
                "rank": 8,
                "owner": "Dylan Harris",
                "team": "Dez-nerys Targaryen",
                "wins": 6,
                "losses": 6,
                "ties": 0,
                "pf": 1130.5,
                "pa": 1193.5
            },
            {
                "rank": 9,
                "owner": "Snap Palmer",
                "team": "I Love Fat Bitches",
                "wins": 5,
                "losses": 7,
                "ties": 0,
                "pf": 1217.1,
                "pa": 1307.2
            },
            {
                "rank": 10,
                "owner": "TJ Knoll",
                "team": "OJ's Parole Board",
                "wins": 3,
                "losses": 9,
                "ties": 0,
                "pf": 1237.1,
                "pa": 1399
            },
            {
                "rank": 11,
                "owner": "Michael Klein",
                "team": "Matty Light",
                "wins": 6,
                "losses": 6,
                "ties": 0,
                "pf": 1180.8,
                "pa": 1181.7
            },
            {
                "rank": 12,
                "owner": "Derek Ansah",
                "team": "Team Ansah",
                "wins": 6,
                "losses": 6,
                "ties": 0,
                "pf": 1360.4,
                "pa": 1287.6
            }
        ]
    },
    {
        "year": 2018,
        "standings": [
            {
                "rank": 1,
                "owner": "Jeremy Lord",
                "team": "Jerry's Cheddar Tuds",
                "wins": 10,
                "losses": 3,
                "ties": 0,
                "pf": 1851,
                "pa": 1500.9
            },
            {
                "rank": 2,
                "owner": "Snap Palmer",
                "team": "BIG PALMER BRAND",
                "wins": 8,
                "losses": 5,
                "ties": 0,
                "pf": 1633.7,
                "pa": 1467.4
            },
            {
                "rank": 3,
                "owner": "Michael Klein",
                "team": "Ze-ke - Os",
                "wins": 6,
                "losses": 7,
                "ties": 0,
                "pf": 1594.7,
                "pa": 1522.1
            },
            {
                "rank": 4,
                "owner": "Dylan Harris",
                "team": "Dilly Dilly",
                "wins": 10,
                "losses": 3,
                "ties": 0,
                "pf": 1657.7,
                "pa": 1427.4
            },
            {
                "rank": 5,
                "owner": "Julian Fife",
                "team": "Fife'd Your Wife",
                "wins": 7,
                "losses": 6,
                "ties": 0,
                "pf": 1505,
                "pa": 1486.9
            },
            {
                "rank": 6,
                "owner": "Tanner Harrison",
                "team": "Urbans Broken Whistle",
                "wins": 7,
                "losses": 6,
                "ties": 0,
                "pf": 1487.3,
                "pa": 1541.4
            },
            {
                "rank": 7,
                "owner": "Jeremy Ansah",
                "team": "Rams D To Brown Town",
                "wins": 6,
                "losses": 7,
                "ties": 0,
                "pf": 1490.8,
                "pa": 1478.9
            },
            {
                "rank": 8,
                "owner": "Justin Wolf",
                "team": "Saquon Deez Nutz",
                "wins": 10,
                "losses": 3,
                "ties": 0,
                "pf": 1701.1,
                "pa": 1410.5
            },
            {
                "rank": 9,
                "owner": "Adam Kester",
                "team": "Pimpin Aint Breesy",
                "wins": 5,
                "losses": 8,
                "ties": 0,
                "pf": 1445.7,
                "pa": 1459.7
            },
            {
                "rank": 10,
                "owner": "TJ Knoll",
                "team": "Your Opponent Left The Match",
                "wins": 0,
                "losses": 13,
                "ties": 0,
                "pf": 1056.6,
                "pa": 1603.6
            },
            {
                "rank": 11,
                "owner": "Austin Clouthier",
                "team": "Frank The Tank",
                "wins": 4,
                "losses": 9,
                "ties": 0,
                "pf": 1288.1,
                "pa": 1477.2
            },
            {
                "rank": 12,
                "owner": "Brett Newman",
                "team": "The Boy With No Team",
                "wins": 5,
                "losses": 8,
                "ties": 0,
                "pf": 1257.2,
                "pa": 1592.9
            }
        ]
    },
    {
        "year": 2019,
        "standings": [
            {
                "rank": 1,
                "owner": "Julian Fife",
                "team": "Fife'd Your Wife",
                "wins": 7,
                "losses": 6,
                "ties": 0,
                "pf": 1373.5,
                "pa": 1419.6
            },
            {
                "rank": 2,
                "owner": "Jeremy Lord",
                "team": "Jerry's Cheddar Tuds",
                "wins": 6,
                "losses": 7,
                "ties": 0,
                "pf": 1396.4,
                "pa": 1311.5
            },
            {
                "rank": 3,
                "owner": "Tanner Harrison",
                "team": "PFT Commenter",
                "wins": 9,
                "losses": 4,
                "ties": 0,
                "pf": 1530.5,
                "pa": 1415.4
            },
            {
                "rank": 4,
                "owner": "Brendan Kearney",
                "team": "McCaffrican Americans",
                "wins": 9,
                "losses": 4,
                "ties": 0,
                "pf": 1551.2,
                "pa": 1444.5
            },
            {
                "rank": 5,
                "owner": "Justin Wolf",
                "team": "Death by JuJuul",
                "wins": 6,
                "losses": 7,
                "ties": 0,
                "pf": 1367.8,
                "pa": 1413.6
            },
            {
                "rank": 6,
                "owner": "TJ Knoll",
                "team": "Zekey Blinders",
                "wins": 7,
                "losses": 6,
                "ties": 0,
                "pf": 1662.2,
                "pa": 1642.2
            },
            {
                "rank": 7,
                "owner": "Jeremy Ansah",
                "team": "The New York Barkley's",
                "wins": 9,
                "losses": 4,
                "ties": 0,
                "pf": 1530.3,
                "pa": 1319.6
            },
            {
                "rank": 8,
                "owner": "Dylan Harris",
                "team": "Knock On Wood",
                "wins": 6,
                "losses": 7,
                "ties": 0,
                "pf": 1452.9,
                "pa": 1479.9
            },
            {
                "rank": 9,
                "owner": "Snap Palmer",
                "team": "BIG PALMER BRAND",
                "wins": 5,
                "losses": 8,
                "ties": 0,
                "pf": 1246.3,
                "pa": 1398.7
            },
            {
                "rank": 10,
                "owner": "Michael Klein",
                "team": "living in a world of suck",
                "wins": 5,
                "losses": 8,
                "ties": 0,
                "pf": 1404.1,
                "pa": 1475.6
            },
            {
                "rank": 11,
                "owner": "Austin Clouthier",
                "team": "Frank The Tank",
                "wins": 4,
                "losses": 9,
                "ties": 0,
                "pf": 1352.3,
                "pa": 1501
            },
            {
                "rank": 12,
                "owner": "Adam Kester",
                "team": "Guice Guice Baby",
                "wins": 5,
                "losses": 8,
                "ties": 0,
                "pf": 1416.6,
                "pa": 1462.5
            }
        ]
    },
    {
        "year": 2020,
        "standings": [
            {
                "rank": 1,
                "owner": "Michael Klein",
                "team": "Your tribe has spoken",
                "wins": 8,
                "losses": 5,
                "ties": 0,
                "pf": 1633.5,
                "pa": 1485.3
            },
            {
                "rank": 2,
                "owner": "TJ Knoll",
                "team": "Golladay Inn",
                "wins": 6,
                "losses": 7,
                "ties": 0,
                "pf": 1549.2,
                "pa": 1607.3
            },
            {
                "rank": 3,
                "owner": "Austin Clouthier",
                "team": "Squilliam Fancy Son",
                "wins": 7,
                "losses": 6,
                "ties": 0,
                "pf": 1574.1,
                "pa": 1564.2
            },
            {
                "rank": 4,
                "owner": "Julian Fife",
                "team": "Chilladelphia Beagles",
                "wins": 7,
                "losses": 6,
                "ties": 0,
                "pf": 1633.2,
                "pa": 1632
            },
            {
                "rank": 5,
                "owner": "Tanner Harrison",
                "team": "King T'CHARKA .",
                "wins": 7,
                "losses": 6,
                "ties": 0,
                "pf": 1578.9,
                "pa": 1541.8
            },
            {
                "rank": 6,
                "owner": "Jeremy Ansah",
                "team": "Ra's Allen Ghul's Destiny",
                "wins": 8,
                "losses": 5,
                "ties": 0,
                "pf": 1653,
                "pa": 1672.8
            },
            {
                "rank": 7,
                "owner": "Snap Palmer",
                "team": "BIG PALMER BRAND",
                "wins": 10,
                "losses": 3,
                "ties": 0,
                "pf": 1903.5,
                "pa": 1619.4
            },
            {
                "rank": 8,
                "owner": "Jeremy Lord",
                "team": "Jerry's Cheddar Tuds",
                "wins": 7,
                "losses": 6,
                "ties": 0,
                "pf": 1632.1,
                "pa": 1691.7
            },
            {
                "rank": 9,
                "owner": "Justin Wolf",
                "team": "Suck my Dick and Balls",
                "wins": 6,
                "losses": 7,
                "ties": 0,
                "pf": 1851.6,
                "pa": 1644.9
            },
            {
                "rank": 10,
                "owner": "Adam Kester",
                "team": "Swift Kick n the Nutz",
                "wins": 4,
                "losses": 9,
                "ties": 0,
                "pf": 1478.7,
                "pa": 1536.9
            },
            {
                "rank": 11,
                "owner": "Brendan Kearney",
                "team": "Pain and Misery",
                "wins": 3,
                "losses": 10,
                "ties": 0,
                "pf": 1341.3,
                "pa": 1677.1
            },
            {
                "rank": 12,
                "owner": "Matt Yamane",
                "team": "LOCKETT IS DEAD TO ME",
                "wins": 5,
                "losses": 8,
                "ties": 0,
                "pf": 1570.2,
                "pa": 1725.9
            }
        ]
    },
    {
        "year": 2021,
        "standings": [
            {
                "rank": 1,
                "owner": "Michael Klein",
                "team": "Your tribe has spoken",
                "wins": 8,
                "losses": 6,
                "ties": 0,
                "pf": 1924,
                "pa": 1714
            },
            {
                "rank": 2,
                "owner": "Tanner Harrison",
                "team": "John T.",
                "wins": 10,
                "losses": 4,
                "ties": 0,
                "pf": 1734.9,
                "pa": 1656.1
            },
            {
                "rank": 3,
                "owner": "Jeremy Lord",
                "team": "Jerry's Cheddar Tuds",
                "wins": 8,
                "losses": 6,
                "ties": 0,
                "pf": 1701.9,
                "pa": 1753.9
            },
            {
                "rank": 4,
                "owner": "Julian Fife",
                "team": "Chilladelphia Beagles",
                "wins": 5,
                "losses": 9,
                "ties": 0,
                "pf": 1694.2,
                "pa": 1829.3
            },
            {
                "rank": 5,
                "owner": "Adam Kester",
                "team": "Officially off Suicide Watch",
                "wins": 8,
                "losses": 6,
                "ties": 0,
                "pf": 1899.2,
                "pa": 1735.8
            },
            {
                "rank": 6,
                "owner": "Justin Wolf",
                "team": "Fuller Chubbs: by Viagra",
                "wins": 9,
                "losses": 5,
                "ties": 0,
                "pf": 1848,
                "pa": 1621.2
            },
            {
                "rank": 7,
                "owner": "Snap Palmer",
                "team": "HOW MY PEACHES TASTE?",
                "wins": 10,
                "losses": 4,
                "ties": 0,
                "pf": 1744.6,
                "pa": 1649
            },
            {
                "rank": 8,
                "owner": "TJ Knoll",
                "team": "Bishop Sycamore",
                "wins": 7,
                "losses": 7,
                "ties": 0,
                "pf": 1799.9,
                "pa": 1739.1
            },
            {
                "rank": 9,
                "owner": "Jeremy Ansah",
                "team": "IMG Academy",
                "wins": 5,
                "losses": 9,
                "ties": 0,
                "pf": 1758.4,
                "pa": 1774.4
            },
            {
                "rank": 10,
                "owner": "Austin Clouthier",
                "team": "Squilliam Fancy Son",
                "wins": 5,
                "losses": 9,
                "ties": 0,
                "pf": 1610.8,
                "pa": 1705.3
            },
            {
                "rank": 11,
                "owner": "Brendan Kearney",
                "team": "Pain and Misery",
                "wins": 5,
                "losses": 9,
                "ties": 0,
                "pf": 1634.6,
                "pa": 1832.1
            },
            {
                "rank": 12,
                "owner": "Matt Yamane",
                "team": "THIS LEAGUE IS A JOKE",
                "wins": 4,
                "losses": 10,
                "ties": 0,
                "pf": 1582.3,
                "pa": 1922.6
            }
        ]
    },
    {
        "year": 2022,
        "standings": [
            {
                "rank": 1,
                "owner": "Snap Palmer",
                "team": "HOW MY PEACHES TASTE?",
                "wins": 9,
                "losses": 5,
                "ties": 0,
                "pf": 1933.5,
                "pa": 1755.6
            },
            {
                "rank": 2,
                "owner": "Michael Klein",
                "team": "Your tribe has SPOKEN",
                "wins": 10,
                "losses": 4,
                "ties": 0,
                "pf": 1978,
                "pa": 1750.3
            },
            {
                "rank": 3,
                "owner": "Julian Fife",
                "team": "Arizona Retardinals",
                "wins": 9,
                "losses": 5,
                "ties": 0,
                "pf": 1559.5,
                "pa": 1610.3
            },
            {
                "rank": 4,
                "owner": "TJ Knoll",
                "team": "AZZ ETN SZN",
                "wins": 10,
                "losses": 4,
                "ties": 0,
                "pf": 1798.8,
                "pa": 1677.3
            },
            {
                "rank": 5,
                "owner": "Tanner Harrison",
                "team": "Rim Reaperrr .",
                "wins": 9,
                "losses": 5,
                "ties": 0,
                "pf": 1796.7,
                "pa": 1584
            },
            {
                "rank": 6,
                "owner": "Austin Clouthier",
                "team": "Squilliam Fancy Son",
                "wins": 7,
                "losses": 7,
                "ties": 0,
                "pf": 1754.7,
                "pa": 1717.6
            },
            {
                "rank": 7,
                "owner": "Justin Wolf",
                "team": "Fuller Chubbs: by Viagra",
                "wins": 9,
                "losses": 5,
                "ties": 0,
                "pf": 1701.1,
                "pa": 1587.1
            },
            {
                "rank": 8,
                "owner": "Matt Yamane",
                "team": "Fire Sale Incoming",
                "wins": 6,
                "losses": 8,
                "ties": 0,
                "pf": 1911.8,
                "pa": 1769.2
            },
            {
                "rank": 9,
                "owner": "Jeremy Ansah",
                "team": "Wentz Down On Er",
                "wins": 3,
                "losses": 11,
                "ties": 0,
                "pf": 1630.8,
                "pa": 1882.4
            },
            {
                "rank": 10,
                "owner": "Adam Kester",
                "team": "Back on Suicide Watch",
                "wins": 6,
                "losses": 8,
                "ties": 0,
                "pf": 1564.6,
                "pa": 1596.9
            },
            {
                "rank": 11,
                "owner": "Jeremy Lord",
                "team": "Jerry's Cheddar Tuds",
                "wins": 3,
                "losses": 11,
                "ties": 0,
                "pf": 1402.7,
                "pa": 1769.4
            },
            {
                "rank": 12,
                "owner": "Brendan Kearney",
                "team": "Kupp Half Empty",
                "wins": 3,
                "losses": 11,
                "ties": 0,
                "pf": 1390.4,
                "pa": 1722.5
            }
        ]
    },
    {
        "year": 2023,
        "standings": [
            {
                "rank": 1,
                "owner": "Justin Wolf",
                "team": "Where's my Kupp??",
                "wins": 6,
                "losses": 8,
                "ties": 0,
                "pf": 1662.4,
                "pa": 1557.6
            },
            {
                "rank": 2,
                "owner": "Tanner Harrison",
                "team": "Rim Reaperrr .",
                "wins": 9,
                "losses": 5,
                "ties": 0,
                "pf": 1490.5,
                "pa": 1506.8
            },
            {
                "rank": 3,
                "owner": "Snap Palmer",
                "team": "Big Dad Energy",
                "wins": 8,
                "losses": 6,
                "ties": 0,
                "pf": 1686.5,
                "pa": 1660.6
            },
            {
                "rank": 4,
                "owner": "TJ Knoll",
                "team": "Addison Wonderland",
                "wins": 7,
                "losses": 7,
                "ties": 0,
                "pf": 1649.2,
                "pa": 1732.5
            },
            {
                "rank": 5,
                "owner": "Austin Clouthier",
                "team": "Squilliam Fancy Son",
                "wins": 10,
                "losses": 4,
                "ties": 0,
                "pf": 1883.4,
                "pa": 1621.3
            },
            {
                "rank": 6,
                "owner": "Adam Kester",
                "team": "Tyreek Down There Somewhere",
                "wins": 7,
                "losses": 7,
                "ties": 0,
                "pf": 1807.6,
                "pa": 1863.5
            },
            {
                "rank": 7,
                "owner": "Jeremy Ansah",
                "team": "Tua Deez Nuts",
                "wins": 7,
                "losses": 7,
                "ties": 0,
                "pf": 1823.2,
                "pa": 1635.7
            },
            {
                "rank": 8,
                "owner": "Michael Klein",
                "team": "Your tribe has SPOKEN",
                "wins": 11,
                "losses": 3,
                "ties": 0,
                "pf": 1861.9,
                "pa": 1663.6
            },
            {
                "rank": 9,
                "owner": "Jeremy Lord",
                "team": "Jerry's Cheddar Tuds",
                "wins": 5,
                "losses": 9,
                "ties": 0,
                "pf": 1561,
                "pa": 1787.1
            },
            {
                "rank": 10,
                "owner": "Brendan Kearney",
                "team": "Tig Ol Griddys",
                "wins": 4,
                "losses": 10,
                "ties": 0,
                "pf": 1591.2,
                "pa": 1759.8
            },
            {
                "rank": 11,
                "owner": "Matt Yamane",
                "team": "Hotel, Odell, Holiday Inn",
                "wins": 5,
                "losses": 9,
                "ties": 0,
                "pf": 1577.9,
                "pa": 1742.5
            },
            {
                "rank": 12,
                "owner": "Julian Fife",
                "team": "Stroud Boys",
                "wins": 5,
                "losses": 9,
                "ties": 0,
                "pf": 1715.7,
                "pa": 1779.5
            }
        ]
    },
    {
        "year": 2024,
        "standings": [
            {
                "rank": 1,
                "owner": "TJ Knoll",
                "team": "Snap's Team #ThankYouSnap",
                "wins": 7,
                "losses": 7,
                "ties": 0,
                "pf": 1706.7,
                "pa": 1603.6
            },
            {
                "rank": 2,
                "owner": "Adam Kester",
                "team": "Hock Tua Pitts on Dat Thang",
                "wins": 8,
                "losses": 6,
                "ties": 0,
                "pf": 1708.2,
                "pa": 1627.7
            },
            {
                "rank": 3,
                "owner": "Michael Klein",
                "team": "Your tribe has SPOKEN",
                "wins": 11,
                "losses": 3,
                "ties": 0,
                "pf": 1855.1,
                "pa": 1560
            },
            {
                "rank": 4,
                "owner": "Ryan Rubley",
                "team": "Just Win, Baby",
                "wins": 10,
                "losses": 4,
                "ties": 0,
                "pf": 1660.4,
                "pa": 1482.7
            },
            {
                "rank": 5,
                "owner": "Jeremy Ansah",
                "team": "Lamb Chowder",
                "wins": 7,
                "losses": 7,
                "ties": 0,
                "pf": 1702.9,
                "pa": 1676.7
            },
            {
                "rank": 6,
                "owner": "Austin Clouthier",
                "team": "Squilliam Fancy Son",
                "wins": 11,
                "losses": 3,
                "ties": 0,
                "pf": 1953.6,
                "pa": 1637.1
            },
            {
                "rank": 7,
                "owner": "Julian Fife",
                "team": "Sewer Jews",
                "wins": 7,
                "losses": 7,
                "ties": 0,
                "pf": 1657.4,
                "pa": 1797.4
            },
            {
                "rank": 8,
                "owner": "Matt Yamane",
                "team": "2 Girls ! Kupp",
                "wins": 7,
                "losses": 7,
                "ties": 0,
                "pf": 1806.8,
                "pa": 1806
            },
            {
                "rank": 9,
                "owner": "Snap Palmer",
                "team": "I Stand With Israel",
                "wins": 5,
                "losses": 9,
                "ties": 0,
                "pf": 1652.8,
                "pa": 1814.4
            },
            {
                "rank": 10,
                "owner": "Jeremy Lord",
                "team": "Jerry's Cheddar Tuds",
                "wins": 5,
                "losses": 9,
                "ties": 0,
                "pf": 1548.7,
                "pa": 1787
            },
            {
                "rank": 11,
                "owner": "Justin Wolf",
                "team": "Herbert the p*rvert",
                "wins": 3,
                "losses": 11,
                "ties": 0,
                "pf": 1573.4,
                "pa": 1844.3
            },
            {
                "rank": 12,
                "owner": "Brendan Kearney",
                "team": "McCaffrican Americans",
                "wins": 3,
                "losses": 11,
                "ties": 0,
                "pf": 1551.9,
                "pa": 1741
            }
        ]
    },
    {
        "year": 2025,
        "standings": [
            {
                "rank": 1,
                "owner": "Ryan Rubley",
                "team": "Rubes",
                "wins": 9,
                "losses": 5,
                "ties": 0,
                "pf": 1748.7,
                "pa": 1809.3
            },
            {
                "rank": 2,
                "owner": "Julian Fife",
                "team": "Najee Germany",
                "wins": 11,
                "losses": 3,
                "ties": 0,
                "pf": 1919.9,
                "pa": 1404
            },
            {
                "rank": 3,
                "owner": "Justin Wolf",
                "team": "Saquon deez lutz",
                "wins": 7,
                "losses": 7,
                "ties": 0,
                "pf": 1562.6,
                "pa": 1612.7
            },
            {
                "rank": 4,
                "owner": "Adam Kester",
                "team": "Hock Tua Pitts on Dat Thang",
                "wins": 7,
                "losses": 7,
                "ties": 0,
                "pf": 1605.5,
                "pa": 1569.3
            },
            {
                "rank": 5,
                "owner": "Austin Clouthier",
                "team": "Squilliam Fancy Son",
                "wins": 10,
                "losses": 4,
                "ties": 0,
                "pf": 1916.6,
                "pa": 1664.4
            },
            {
                "rank": 6,
                "owner": "TJ Knoll",
                "team": "She Diggs in my B. Hall",
                "wins": 6,
                "losses": 8,
                "ties": 0,
                "pf": 1711.1,
                "pa": 1633
            },
            {
                "rank": 7,
                "owner": "Jeremy Ansah",
                "team": "Kamara Harris",
                "wins": 9,
                "losses": 5,
                "ties": 0,
                "pf": 1782.6,
                "pa": 1522
            },
            {
                "rank": 8,
                "owner": "Jeremy Lord",
                "team": "Jerry's Cheddar Tuds",
                "wins": 7,
                "losses": 7,
                "ties": 0,
                "pf": 1582.3,
                "pa": 1641.4
            },
            {
                "rank": 9,
                "owner": "Brendan Kearney",
                "team": "My Johnston Hurts your Skattebo",
                "wins": 5,
                "losses": 9,
                "ties": 0,
                "pf": 1666.1,
                "pa": 1838.4
            },
            {
                "rank": 10,
                "owner": "Matt Yamane",
                "team": "All Our Mothers Took Tylenol",
                "wins": 3,
                "losses": 11,
                "ties": 0,
                "pf": 1310.7,
                "pa": 1919.1
            },
            {
                "rank": 11,
                "owner": "Michael Klein",
                "team": "Your tribe has SPOKEN",
                "wins": 5,
                "losses": 9,
                "ties": 0,
                "pf": 1609.6,
                "pa": 1620.4
            },
            {
                "rank": 12,
                "owner": "Snap Palmer",
                "team": "BOCAINE ADDICTS",
                "wins": 5,
                "losses": 9,
                "ties": 0,
                "pf": 1655.7,
                "pa": 1837.4
            }
        ]
    }
];
//# sourceMappingURL=history.js.map